module.exports = __webpack_public_path__ + "static/media/crossingsImage1Mobile.51783aef.png";